























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class TablePagination extends Vue {
  // Props
  @Prop()
  public perPage!: number
  @Prop()
  public currentPage!: number
  @Prop()
  public numofPage!: number

  @Prop()
  public limitedPagination!: boolean

  public perPageVal: number = 0
  public currentPageVal: number = 0

  @Watch('perPageVal')
  @Watch('currentPageVal')
  public perPageValChanged() {
    this.$emit('update:perPage', this.perPageVal)
    this.$emit('update:currentPage', this.currentPageVal)
  }

  private created() {
    this.perPageVal = this.perPage
    this.currentPageVal = this.currentPage
  }
}
